import { signOut as signOutAmplify } from '@aws-amplify/auth';

export const signOut = async () => signOutAmplify();
